<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400px">
      <v-card>
        <v-card-title style="justify-content: center;">{{$t('user.userAlreadyExists')}}</v-card-title>
          <v-card-text class="pb-0">{{$t('user.associateUserText')}}</v-card-text>
          <validation-observer ref="form">
            <v-form @submit.prevent="onSubmit">
              <v-container fluid>
                <validation-provider rules="required" v-slot="{ errors }">
                  <v-select
                      v-model="role"
                      :items="roleOptions"
                      :error-messages="errors"
                      :label="$t('user.role')"
                      required
                      >
                  </v-select>
                </validation-provider>
                <validation-provider :rules="role == 'oms-admin' ? '' : 'required'" v-slot="{ errors }">
                  <v-autocomplete
                      v-model="userStore"
                      :items="storeList"
                      :loading="loadingStores"
                      :label="$t('user.store')"
                      :error-messages="errors"
                      item-text="name"
                      item-value="location_id"
                      required>
                  </v-autocomplete>
              </validation-provider>
              </v-container>
              <v-card-actions class="pa-0">
                <v-btn
                    color="primary"
                    tile
                    class="ml-0"
                    style="width: 50%;"
                    type="submit"
                >{{$t("components.modal.btn.validate")}}</v-btn>
                <v-btn
                    color="secondary"
                    tile
                    class="ml-0"
                    style="width: 50%;"
                    @click="show = false"
                >{{$t("components.modal.btn.cancel")}}</v-btn>
                </v-card-actions>
            </v-form>
          </validation-observer>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import { EventBus } from '../../event-bus'


extend('required', {
  ...required,
  message: 'This field is required'
});
export default {
  name: "UserAssociationDialogue",
  components: {
      "validation-provider": ValidationProvider,
      "validation-observer": ValidationObserver
  },
  data() {
    return {
      roleOptions: [
        {text:this.$t('users.seller'), value:"default-user"},
        {text:this.$t('users.shopManager'), value:"oms-shop-manager"},
        {text:this.$t('users.customerService'), value:"oms-customer-service"},
        {text:this.$t('users.admin'), value:"oms-admin"},
      ],
      storeList: [],
      role: '',
      userStore: '',
      loadingStores: false
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId:{
      type:String,
      required: true
    },
    user:{
      type:Object,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  mounted () {
    this.getStores()
  },
  methods: {
    onSubmit: function() {
      this.$refs.form.validate().then(success => {
        if(success){
          this.addRegistration()
        }
      })
    },
    getStores(){
        this.loadingStores = true
        let myInit = {
            headers: {
                "Authorization": 'Bearer ' + this.$auth.accessToken
            },
            queryStringParameters: {
                itemsPerPage: false
            }
        }
        this.$Amplify.API.get("locations", '/v1/int/locations', myInit)
        .then((res) => {
            this.storeList = res.data
            this.loadingStores = false
        })
        .catch((e) => {
            console.log(e)
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: "error during location loading",
            color: "error"
          })
            this.loadingStores = false
        })
    },
    addRegistration () {
      let myInit = {
        headers: {
          Authorization: "Bearer " + this.$auth.accessToken,
        },
        body: {
          registration: {
            applicationId: process.env.VUE_APP_SSO_APP_ID,
            roles: [this.role]
          },
        }
      };
      this.$Amplify.API.post("users", '/user/registration/'+ this.userId, myInit)
        .then(() => {
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('users.associationDone'),
            color: "success"
          })
          let updateUserData = {
            user : this.user
          }
          let otherLocations = updateUserData.user.data?.other_locations || []
          if(!otherLocations.includes(this.userStore)){
            otherLocations.push(this.userStore)
          }
          updateUserData.user.data = updateUserData.user.data || {};
          updateUserData.user.data.userStore = this.userStore;
          updateUserData.user.data.main_location = this.userStore;
          updateUserData.user.data.other_locations = otherLocations;

          myInit.body = updateUserData
          this.$Amplify.API.put('users', '/user/' + this.userId, myInit)
            .then(() => {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('user.userUpdated'),
                color: "success"
              })
              this.$emit("close")
            })
            .catch((e) => {
              let error = e.response.data
              if (error.fieldErrors) {
                for (const field in error.fieldErrors) {
                  EventBus.$emit('displaySnackbar', {
                    display: true,
                    text: error.fieldErrors[field][0].message,
                    color: "error"
                  })
                }
              } else if (error.generalErrors) {
                for (const index in error.generalErrors) {
                  EventBus.$emit('displaySnackbar', {
                    display: true,
                    text: error.generalErrors[index].message,
                    color: "error"
                  })
                }
              }
            })
        })
        .catch((e) => {
          let error = e.response.data
          if (error.fieldErrors) {
            for (const field in error.fieldErrors) {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: error.fieldErrors[field][0].message,
                color: "error"
              })
            }
          } else if (error.generalErrors) {
            for (const index in error.generalErrors) {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: error.generalErrors[index].message,
                color: "error"
              })
            }
          }
        })
    }
  }
};
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>
